import styled from 'styled-components'

export const Container = styled.div`
  align-self: stretch;
`

export const Charts = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`
